export function getNextNodeOpenState(currentState: boolean | undefined): boolean {
  return currentState === false
}

export interface InspectionLessonPath {
  curriculumId: number
  courseId: number
  moduleId: number
  lessonId: number
}

export function createInspectionLessonPath(
  ancestorIds: number[],
  lessonId: number
): InspectionLessonPath | null {
  if (ancestorIds.length !== 3) {
    return null
  }

  const [curriculumId, courseId, moduleId] = ancestorIds
  return { curriculumId, courseId, moduleId, lessonId }
}

export function isSameInspectionLessonPath(
  first: InspectionLessonPath | null | undefined,
  second: InspectionLessonPath | null | undefined
): boolean {
  return Boolean(
    first &&
    second &&
    first.curriculumId === second.curriculumId &&
    first.courseId === second.courseId &&
    first.moduleId === second.moduleId &&
    first.lessonId === second.lessonId
  )
}

export function getInspectionGameQueryKey(path: InspectionLessonPath) {
  return [
    'inspection',
    'games-by-lesson-path',
    path.curriculumId,
    path.courseId,
    path.moduleId,
    path.lessonId,
  ] as const
}
